<template>
  <div v-if="visible" class="emoji-picker-container" :class="containerClass">
    <div class="emoji-picker" :class="pickerClass" @click.stop>
      <div class="emoji-grid">
        <span
          v-for="emoji in commonEmojis"
          :key="emoji"
          @click="handleEmojiClick(emoji)"
          class="emoji-item"
        >
          {{ emoji }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmojiPicker',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    containerClass: {
      type: String,
      default: 'position-relative',
    },
    pickerClass: {
      type: String,
      default: '',
    },
  },
  emits: ['select'],
  data() {
    return {
      commonEmojis: [
        '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣',
        '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰',
        '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜',
        '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏',
        '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣',
        '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠',
        '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨',
        '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥',
        '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😧',
        '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐',
        '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕',
      ],
    };
  },
  methods: {
    handleEmojiClick(emoji) {
      this.$emit('select', emoji);
    },
  },
};
</script>

<style scoped>
.emoji-picker-container {
  margin-top: 8px;
}

.emoji-picker {
  position: absolute;
  bottom: 100%;
  background: white;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}

.emoji-picker-left {
  left: 0;
}

.emoji-picker-right {
  right: 0;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 4px;
}

.emoji-item {
  cursor: pointer;
  padding: 4px;
  text-align: center;
  font-size: 1.2rem;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.emoji-item:hover {
  background-color: #f1f1f1;
}
</style>

